// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friends-join-modal__form{padding:1rem}.friends-join-modal p{margin-bottom:1em;max-width:30rem}.friends-join-modal .field-input+.field-input{margin-top:1rem}.friends-join-modal #field-remote-peer-id{text-align:center;font-family:monospace;letter-spacing:.25em}@media (min-width:40rem){.friends-join-modal__form{padding:2rem}}@media (min-width:60rem){.friends-join-modal__form{padding:2rem}}", ""]);
// Exports
module.exports = exports;
